//
// PLEASE PAY ATTENTION TO https://www.w3.org/WAI/WCAG21/Techniques/general/G65
//

import { sanitizeTitle } from "../../utils/customSanitize";
import { CustomLink } from "../Global/CustomLink";
import styles from "./Breadcrumbs.module.scss";
import { ParentsType } from "../../wp/getParentPages";
import { getTitle } from "../../wp/getHeader";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { Post } from "@/wp/types/client";
import { WP_Term } from "wp-types";

export interface BreadcrumbProps {
  post: Post;
  breadcrumbPositon:
    | "is-justify-content-flex-start"
    | "is-justify-content-center"
    | "is-justify-content-flex-end";
  showOnMobile?: boolean;
  parents: ParentsType;
  extraClass?: string;
}

export const Breadcrumbs = ({
  post,
  breadcrumbPositon,
  parents,
  // showOnMobile,
  extraClass = "",
}: BreadcrumbProps) => {
  const title = getTitle({ post });
  const { getLabel } = useGlobalContext();

  const CATEGORY_LABELS: Record<string, string> = {
    "tipps-tricks": "Tipps & Tricks",
    "gut-zu-wissen": "Gut zu wissen",
  };

  const isBlog = post.type === "blog";
  let effectiveParents: ParentsType = parents;
  if (isBlog) {
    const cat = getPrimaryCategory(post);
    const catSlug = cat?.slug || "allgemein";

    const labelOverride = CATEGORY_LABELS[catSlug];
    const catName = (labelOverride || catSlug.replace(/-/g, " ")).trim();

    effectiveParents = [
      {
        title: catName,
        url: `/${catSlug}/`,
        isEmptyParentPage: false,
      },
    ];
  }
  return (
    <div className="nav-oriented-breadcrumbs">
      <nav
        aria-label="Breadcrumbs"
        className={`container ${styles.breadcrumbs} ${extraClass}`}
      >
        <ul className={`${breadcrumbPositon}`}>
          <li>
            <CustomLink href="/" target={"_self"} className={` ${styles.item}`}>
              {getLabel("breadcrumb_root")}
            </CustomLink>
          </li>
          {effectiveParents
            .filter((p) => !p.isEmptyParentPage)
            .map((el, i) => {
              const removeStrongTitle = el.title
                .replace(/<strong>/g, "")
                .replace(/<\/strong>/g, "");
              return (
                <li key={i}>
                  <CustomLink
                    href={el.url}
                    target="_self"
                    className={` ${styles.item}`}
                  >
                    {removeStrongTitle}
                  </CustomLink>
                </li>
              );
            })}
          <li aria-current="page">
            <span
              className={` ${styles.item}`}
              dangerouslySetInnerHTML={{
                __html: sanitizeTitle(title ?? ""),
              }}
            ></span>
          </li>
        </ul>
      </nav>
    </div>
  );
};

function getPrimaryCategory(post: Post): WP_Term | null {
  try {
    const href = (post as Post).link || "";
    const u = new URL(href);
    const seg = u.pathname.split("/").filter(Boolean)[0];
    if (seg) {
      return { slug: seg, name: seg.replace(/-/g, " ") } as WP_Term;
    }
  } catch {
    // noop
  }

  return null;
}
